import { useEffect, useRef, useState } from "react";
import { PolarAreaChart} from "../../PlayerDetail/Attributes/RolesPlayedUtils";
import {archetypeColorIndexes,IArchetypeData, ITeamArchetypeData, processArchetypeData, processTeamArchetypeData } from '../../../types/IRolesPlayedUtils'
import { ArchetypeItem, ArchetypeSidebar, ConnectionContainer, ConnectionSVG, EyeIconWrapper, HeaderContent} from "../../../styled-components/RolesPlayedUtilsStyles"
import * as d3 from "d3";
import EyeIcon from "../../../assets/icons/VisibleON.png";
import apiUrls from "../../../config/apiUrls";
import { fetchData, postData } from "../../../services/api";
import handleApiResponse from "../../../utils/handleApiResponse";
import IApiResponse from "../../../types/IApiResponse";
import { useLoading } from "../../../contexts/LoadingContext";
import { ModuleSpinner } from "../../../ui/LoadingSpinner/ModuleSpinner";
import InfoIcon from '../../../assets/icons/infoicon.svg';
import { ArchetypeInfoDrawer, TeamArchetypeInfoDrawer } from "../../../pages/Chemistry/UIContent";
import { useSquadSystemFitContext } from "../../../contexts/SquadSystemFitContext";
import PositiveArrow from "../../../assets/icons/PositiveArrow.png";
import NegativeArrow from "../../../assets/icons/NegativeArrow.png";
import { InfoOutlined } from "@mui/icons-material";
import { ChemistryData, fetchChemistryData, fetchChemistrySummaryData, TeamResultSummary } from "../../../pages/Chemistry/Utils";
import { ChemistryPlayerPositions, TeamChemistry } from "../../../types/IOption";
import LabelText from "../../../ui/LabelText";
import SecondaryButton from "../../../ui/SecondaryButton";
import styled from "styled-components";
import ClubInitialSearch from "../../ClubLanding/ClubSearch/ClubInitialSearch";
import PlayerInitialSearch from "../../PlayerLanding/PlayerSearch/PlayerInitialSearch";
import { useSidebar } from "../../../contexts/SidebarContext";
import { Drawer } from "@mui/material";
import { useClubSearch } from "../../../contexts/ClubSearchContext";
import {
  BackToTeamChemistryBtn
} from "../../../pages/Chemistry/StyledChemistryElements";
import ResetIcon from "../../../assets/icons/Reset.png";

const Line = styled.div`
    width: -webkit-fill-available;
    height: 2px;
    border: 1px solid #DADADA;
`
interface IRolesPlayedProps {
  playerName?: string;
  teamId: number;
  seasonId: number;
}



export const TeamRolesPlayed: React.FC<IRolesPlayedProps> = ({ playerName, teamId, seasonId }) => {
  
  const {compareClubLogoUrl , compareClubName , clubSearchOpen , setIsClubSearchOpen}= useClubSearch()
  const [archetypeData, setArchetypeData] = useState<ITeamArchetypeData[]>([]);
  const [comparisonTeamData, setComparisonTeamData] = useState<ITeamArchetypeData[]>([]);
  const [comparisonTeamFormationData, setComparisonTeamFormationData] = useState<ITeamArchetypeData>();
  const [activeArchetype, setActiveArchetype] = useState<number>(0);
  const totalMinutes = archetypeData?.reduce((sum, archetype) => sum + archetype.minutes, 0);
  const activeItemRef = useRef<HTMLDivElement>(null);
  const chartRef = useRef<HTMLDivElement>(null);
  const connectionRef = useRef<SVGSVGElement>(null);
  const {startLoading, stopLoading ,loading} = useLoading();
  const [isTeamRolesPlayedLoading , setIsTeamRolesPlayedLoading] = useState<boolean>(false)
  const [teamsidebarOpen, setTeamSidebarOpen] = useState<boolean>(false);
  const [activeformation , setActiveFormation] = useState<string>("")
  const [activeArcheTypeId, setActiveArcheTypeId] = useState<number>(0);
  const [activeArcheTypeName, setActiveArcheTypeName] = useState<string>("");
  const [leagueValues, setLeaguevalues] = useState<TeamResultSummary>({
      leaguePosition: 0,
      matchesWon: 0,
      matchesLost: 0,
      matchesDraw: 0,
      totalGoals:0,
      totalGoalsAgainst:0,
      xGoals:0,
      xGoalAgainst:0,
      coaches:[]
  });
  const [activeTeamGraph , setActiveTeamGraph] = useState<number>();
  // const [clubSearchOpen , setIsClubSearchOpen] = useState<boolean>(false)
  const {clubCompareId , setIsClubCompareId , setCompareClubLogoUrl , setCompareClubName ,teamCompareAttributesData, setTeamCompareAttributesData}= useClubSearch();

  const fetchSpiderData = async (teamId: number,seasonId: number,isComparison: boolean) => {
      setIsTeamRolesPlayedLoading(true);
      const response: IApiResponse<ITeamArchetypeData[]> = await fetchData(
        `${apiUrls["GetTeamSpiderGraphAsync"]}/${teamId}?seasonId=${seasonId}`
      );

      handleApiResponse(
        response,
        (spiderData) => {
          setIsTeamRolesPlayedLoading(false);
          const sortedArchtypeData = spiderData?.sort((a, b) => b?.usagePercentage - a?.usagePercentage);
          if (isComparison) {
            // spiderData.filter(archtype => archtype?.formationName === activeformation)
            setComparisonTeamData(spiderData);

          } else {
            setActiveArcheTypeId(sortedArchtypeData[0]?.archetypeId)
            setActiveArcheTypeName(sortedArchtypeData[0]?.archetypeName!);
            setActiveFormation(sortedArchtypeData[0]?.formationName!)
            setActiveTeamGraph(sortedArchtypeData[0]?.archetypeId! + sortedArchtypeData[0]?.coachId! + sortedArchtypeData[0]?.competitionId! + sortedArchtypeData[0]?.ppg! + sortedArchtypeData[0]?.usagePercentage!)
            setArchetypeData(sortedArchtypeData);
          }
          // setActiveArchetype(
          //   spiderData[0]?.archetypeId! +
          //     spiderData[0]?.competitionId +
          //     spiderData[0]?.seasonId
          // );
        },
        (error) => {
          setIsTeamRolesPlayedLoading(false);
          console.error("Error fetching Spider Data:", error);
        }
      );
  };

    useEffect(() => {
      if (teamId > 0 && seasonId > 0) {
        fetchChemistrySummaryData(false, teamId, seasonId, [], setLeaguevalues, startLoading, stopLoading);
      }
    }, [teamId, seasonId]);

    useEffect(() => {
      if (teamId > 0 && seasonId > 0) {
        fetchSpiderData(teamId , seasonId , false);
      }
    }, [teamId, seasonId]);

    useEffect(()=>{
      if(clubCompareId! > 0 && clubCompareId !== teamId){
        fetchSpiderData(clubCompareId,0 , true)
      }
    },[clubCompareId,teamId])


  useEffect(() => {
    if (!activeItemRef.current || !chartRef.current || !connectionRef.current) return;
    const itemRect = activeItemRef.current.getBoundingClientRect();
    const chartRect = chartRef.current.getBoundingClientRect();
    const containerRect = connectionRef.current.getBoundingClientRect();
    const startX = itemRect.right - containerRect.left;
    const startY = itemRect.top + itemRect.height / 2 - containerRect.top;
    const chartCenterX = chartRect.left + chartRect.width / 2 - containerRect.left;
    const chartCenterY = chartRect.top + chartRect.height / 2 - containerRect.top;
    const chartRadius = Math.min(chartRect.width, chartRect.height) / 2 - 20;
    const angleToCenter = Math.atan2(chartCenterY - startY, chartCenterX - startX);
    const adjustedAngle = angleToCenter - Math.PI / 6;
    const endX = chartCenterX - Math.cos(adjustedAngle) * chartRadius;
    const endY = chartCenterY - Math.sin(adjustedAngle) * chartRadius;
    const path = `
      M ${startX} ${startY}
      C ${startX + 50} ${startY},
        ${endX - 50} ${endY},
        ${endX} ${endY}
    `;
    const svg = d3.select(connectionRef.current);
    svg.selectAll("*").remove();
    svg
      .append("path")
      .attr("d", path)
      .style("fill", "none")
      .style(
        "stroke",
        archetypeColorIndexes[archetypeData?.findIndex((a) => ((a?.formationName! === activeformation) && (a?.archetypeId! + a?.coachId! + a?.competitionId! + a?.ppg! + a?.usagePercentage! === activeTeamGraph!)))]
      )
      .style("stroke-width", "3")
      .style("opacity", "0.6");
  }, [activeformation, activeTeamGraph, archetypeData]);

  const handleResetTeamArchType = () => {
      setCompareClubName("");
      setCompareClubLogoUrl("");
      setIsClubCompareId(0)
      setComparisonTeamData([])
      setTeamCompareAttributesData([]);
  }

  return (
    <>
    <div className="roles-played-master">
      <ConnectionContainer>
          {/* {archetypeData?.length === 0 && 
              <>
                <div className="single-archetype-container" style={{display:'flex',gap:'10px',alignItems:'center',position:'relative'}}>
                  <p className="archetype-name-sidebar" >{archetypeData?.[0]?.archetypeName}</p>
                  <div className='attributesonpitch-info-icon' style={{position:'static' , cursor:'pointer'}} onClick={() => setTeamSidebarOpen(true)}>
                             <img src={InfoIcon} alt="archetpe-info" className="archetype-info-icon"/>
                  </div>
                  <p className="archetype-minutes-sidebar">
                    {archetypeData?.[0]?.minutes?.toFixed(0)}
                  </p>
                </div>
               
              </>
          } */}
          {archetypeData?.length === 1 && (
            <>
            <div className="single-archetype-container">
                <div style={{display:'flex',alignItems:'center',gap:'6px'}}>
                  <p className="archetype-name-sidebar">{archetypeData?.[0]?.archetypeName!}</p>
                  <div className='attributesonpitch-info-icon' style={{position:'static'}}>
                      <img src={InfoIcon} alt="archetpe-info" className="archetype-info-icon" onClick={() => setTeamSidebarOpen(true)} />   
                  </div>
                </div>
                <div className="archtype-main">
                    <div className="archtype-info-container" style={{left:'0px'}}>
                        <div className="archetype-info-content">
                          <p className="archetype-minutes-sidebar">
                            <span className="archetype-minutes-number-sidebar">Formation</span>
                            {archetypeData?.[0]?.formationName!}
                          </p>
                          <p className="archetype-minutes-sidebar">
                            <span className="archetype-minutes-number-sidebar">Usage Percentage</span>
                            {archetypeData?.[0]?.usagePercentage!} %
                          </p>
                          <p className="archetype-minutes-sidebar">
                            <span className="archetype-minutes-number-sidebar">Points Per Game</span>
                            {archetypeData?.[0]?.ppg!}
                          </p>
                          {archetypeData?.[0]?.minutes !== null &&(
                              <p className="archetype-minutes-sidebar">
                                <span className="archetype-minutes-number-sidebar">MINS PLAYED</span>
                                {archetypeData?.[0]?.minutes?.toFixed(0)}
                              </p>
                          )}
                          {archetypeData?.[0]?.coachName !== null &&(
                          <p className="archetype-minutes-sidebar">
                            <span className="archetype-minutes-number-sidebar">Manager</span>
                            {archetypeData?.[0]?.coachName!}
                          </p>)}
                          {/* <LabelText className="archtype-tag-text">{archetype?.formationName!}</LabelText>
                            <LabelText className="archtype-tag-text">Usage Percentage = {archetype?.usagePercentage!} %</LabelText>
                            <LabelText className="archtype-tag-text">Points Per Game = {archetype?.ppg!}</LabelText> */}
                            
                        </div>
                    </div>
                </div>
                <div className="archtype-main">
                    <div className="archtype-info-container" style={{left:'0px'}}>
                        <div className="archetype-info-content" style={{paddingLeft:'0px',paddingTop:'10px'}}>
                            <Line/>
                              <div className="archtype-info">
                                  <div className="archtype-tag" style={{background:'transparent',border:'1px solid black'}}></div>
                                  {compareClubLogoUrl && compareClubName ? (
                                      <div style={{display:'flex',alignItems:'center',gap:'4px'}}>
                                        =  <img src={compareClubLogoUrl!} width={18} height={18} alt="club-logo" className="club-logo" />
                                        <LabelText className="archtype-tag-text">{compareClubName!}</LabelText>
                                      </div>
                                  ):(
                                    <LabelText className="archtype-tag-text">=  Av. for this style of play</LabelText>
                                  )}
                              </div>
                              <div className="archtype-info">
                                  <SecondaryButton label="Compare to other team" className="compare-btn" onClick={()=>{setIsClubSearchOpen(true)}}/>
                              </div>
                          </div>
                      </div>   
                </div>
            </div>
            </>
          )}
        <div className="archetype-master-container" style={{border:'none'}}>
          {archetypeData?.length! > 1 && 
          <ArchetypeSidebar isSingleArchetype={archetypeData?.length === 1}>
            {archetypeData?.map((archetype, index) => {
              const heightPercentage = (archetype.minutes / totalMinutes!) * 100;
              const colorIndex = index % archetypeColorIndexes.length;
              const archetypeKey = archetype?.archetypeId! + archetype?.coachId! + archetype?.competitionId! + archetype?.ppg! + archetype?.usagePercentage!
              return (
                <ArchetypeItem
                  key={archetypeKey}
                  heightPercentage={50}
                  ref={((archetype?.formationName) === activeformation) && (archetype?.archetypeId! + archetype?.coachId! + archetype?.competitionId! + archetype?.ppg! + archetype?.usagePercentage! === activeTeamGraph!)? activeItemRef : null}
                  colorIndex={colorIndex}
                  isSingleArchetype={archetypeData?.length === 1}
                  isFirst={index === 0}
                  isLast={index === archetypeData.length - 1}
                >
                  <div className="spider-info-label">
                      <EyeIconWrapper
                        isActive={(activeformation === archetype?.formationName!) && (archetype?.archetypeId! + archetype?.coachId! + archetype?.competitionId! + archetype?.ppg! + archetype?.usagePercentage! === activeTeamGraph!) }
                        onClick={() => {
                          // setActiveArchetype(archetype?.archetypeId + archetype?.competitionId + archetype?.seasonId)
                          setActiveArcheTypeId(archetype?.archetypeId!)
                          setActiveFormation(archetype?.formationName!)
                          setActiveTeamGraph(archetype?.archetypeId! + archetype?.coachId! + archetype?.competitionId! + archetype?.ppg! + archetype?.usagePercentage!)
                          setActiveArcheTypeName(archetype?.archetypeName!)
                        }
                      }
                      >
                        <img src={EyeIcon} alt="expand-eye-icon" className="archetypes-exapnd-eye-icon" />
                      </EyeIconWrapper>
                      <div className="archetype-name-container">
                        <p className="archetype-name-sidebar">{archetype?.archetypeName}  
                        </p>
                        {archetype?.minutes !== null &&(
                            <p className="archetype-minutes-sidebar">
                              <span className="archetype-minutes-number-sidebar">MINS PLAYED</span>
                              {archetype?.minutes?.toFixed(0)}
                            </p>
                        )}
                        
                      </div>
                      {(archetype?.formationName === activeformation!) && (archetype?.archetypeId! + archetype?.coachId! + archetype?.competitionId! + archetype?.ppg! + archetype?.usagePercentage! === activeTeamGraph!) && (
                             <img src={InfoIcon} alt="archetpe-info" className="archetype-info-icon" onClick={() => setTeamSidebarOpen(true)}/>

                      )}

                  </div>
                  <div className="archtype-main">
                            <div className="archtype-info-container">
                                <div className="archetype-info-content">
                                  <p className="archetype-minutes-sidebar">
                                    <span className="archetype-minutes-number-sidebar">Formation</span>
                                    {archetype?.formationName!}
                                  </p>
                                  <p className="archetype-minutes-sidebar">
                                    <span className="archetype-minutes-number-sidebar">Usage Percentage</span>
                                    {archetype?.usagePercentage!} %
                                  </p>
                                  <p className="archetype-minutes-sidebar">
                                    <span className="archetype-minutes-number-sidebar">Points Per Game</span>
                                    {archetype?.ppg!}
                                  </p>
                                  <p className="archetype-minutes-sidebar">
                                    <span className="archetype-minutes-number-sidebar">Manager</span>
                                    {archetype?.coachName!}
                                  </p>
                                  {/* <LabelText className="archtype-tag-text">{archetype?.formationName!}</LabelText>
                                    <LabelText className="archtype-tag-text">Usage Percentage = {archetype?.usagePercentage!} %</LabelText>
                                    <LabelText className="archtype-tag-text">Points Per Game = {archetype?.ppg!}</LabelText> */}
                                     
                                </div>
                            </div>
                  </div>
                  {(archetype?.formationName === activeformation) && (archetype?.archetypeId! + archetype?.coachId! + archetype?.competitionId! + archetype?.ppg! + archetype?.usagePercentage! === activeTeamGraph!) &&(
                      <div className="archtype-main">
                            <div className="archtype-info-container">
                                <div className="archetype-info-content">
                                  <Line/>
                                    <div className="archtype-info">
                                        <div className="archtype-tag" style={{background:'transparent',border:'1px solid black'}}></div>
                                        {compareClubLogoUrl && compareClubName ? (
                                            <div style={{display:'flex',alignItems:'center',gap:'4px'}}>
                                              =  <img src={compareClubLogoUrl} width={18} height={18} alt="club-logo" className="club-logo" />
                                              <LabelText className="archtype-tag-text">{compareClubName}</LabelText>
                                            </div>
                                        ):(
                                          <LabelText className="archtype-tag-text">=  Av. for this style of play</LabelText>
                                        )}
                                    </div>
                                    <div className="archtype-info">
                                        <SecondaryButton label="Compare to other team" className="compare-btn" onClick={()=>{setIsClubSearchOpen(true)}}/>
                                    </div>
                                   
                                    
                                  </div>
                            </div>   
                      </div>
                  )}
                   
                  
                </ArchetypeItem>
              );
            })}
          </ArchetypeSidebar>
          } 
          
          <div className="roles-played-spidergram" ref={chartRef}>
            {archetypeData
              ?.filter((archetype) => (archetype?.formationName!) === activeformation  && (archetype?.archetypeId! + archetype?.coachId! + archetype?.competitionId! + archetype?.ppg! + archetype?.usagePercentage! === activeTeamGraph!))
              ?.map((archetype) => (
              // {archetypeData.length > 0 &&(
                  <PolarAreaChart
                    key={(archetype?.formationName!)}
                    data={processTeamArchetypeData(archetype)}
                    averageData={processTeamArchetypeData(comparisonTeamData[0]!)}
                    isForComparison={clubCompareId! > 0}
                    height={600}
                    width={682}
                    colorIndex={archetypeData.findIndex((a) => (a?.formationName === activeformation) && (archetype?.archetypeId! + archetype?.coachId! + archetype?.competitionId! + archetype?.ppg! + archetype?.usagePercentage! === activeTeamGraph!)) % archetypeColorIndexes.length}
                  />
              // )} 
           ))} 
          </div>
          <div className="reset-team-archtype">
            
           <BackToTeamChemistryBtn onClick={() => handleResetTeamArchType()} disabled={clubCompareId === 0}>
            <img src={ResetIcon} alt="reset icon" /> Reset team
          </BackToTeamChemistryBtn>  
          </div>
          <div className="attributes-archtype-main-info">
              <div className="archetype-info-content">
                  <div className="archtype-info">
                      <div className="archtype-tag" style={{background:'#64ADDB'}}></div>
                      <LabelText className="archtype-tag-text">Defensive</LabelText>
                  </div>
                  <div className="archtype-info">
                      <div className="archtype-tag" style={{background:'#C9F0B5'}}></div>
                      <LabelText className="archtype-tag-text">Build up play</LabelText>
                  </div>
                  <div className="archtype-info">
                      <div className="archtype-tag" style={{background:'#FFC2C2'}}></div>
                      <LabelText className="archtype-tag-text">Final third</LabelText>
                  </div>
                </div>
              </div>
        </div>
        {archetypeData?.length! > 1 && <ConnectionSVG ref={connectionRef} />}
      </ConnectionContainer>
      {isTeamRolesPlayedLoading && <ModuleSpinner/>}
      {archetypeData?.length! > 0  && <TeamArchetypeInfoDrawer
            teamsidebarOpen={teamsidebarOpen}
            setTeamSidebarOpen={setTeamSidebarOpen}
            archetypeName={activeArcheTypeName}
            activeArchetypeID={activeArcheTypeId}
      />}
           
    </div>

          {clubSearchOpen && <ClubInitialSearch open={clubSearchOpen} setIsOpen={setIsClubSearchOpen} archtypeId={archetypeData[0]?.archetypeId!}/>}

    </>
  );
};
